import { render, staticRenderFns } from "./LotesLista.vue?vue&type=template&id=59767213&scoped=true&"
import script from "./LotesLista.vue?vue&type=script&lang=js&"
export * from "./LotesLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59767213",
  null
  
)

export default component.exports